export default __webpack_public_path__ + "static/media/sun.72a1a73b.svg";